import { BeneficiaryInsightDimension } from '@repo/shared/dtos/beneficiary'

import { FormType } from '../types'
import RangeNumberBuckets from './number/RangeNumberBuckets'
import SimpleNumberBuckets from './number/SimpleNumberBuckets'

export function NumberBuckets({
  form,
  dimension,
  dimensionIndex,
  onChange,
}: {
  form: FormType
  dimension: BeneficiaryInsightDimension
  dimensionIndex: number
  onChange: (dimension: BeneficiaryInsightDimension) => void
}) {
  const mode = form.watch('dimensionModes')[dimensionIndex]!.number ?? 'simple'

  const updateDimension = (dimension: BeneficiaryInsightDimension) => {
    onChange(dimension)
  }

  return (
    <div className="rounded-lg border border-primary-200 p-4 bg-gray-50 space-y-4">
      {mode === 'simple' && (
        <SimpleNumberBuckets dimension={dimension} onChange={updateDimension} />
      )}
      {mode === 'range' && <RangeNumberBuckets dimension={dimension} onChange={updateDimension} />}
    </div>
  )
}
